<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <CRow>
        <CCol cols="12" md="12" lg="12">
          <b-button variant="primary" class="mb-4" v-b-modal.modal-input-hirarki>
            <CIcon name="cil-plus" />
            {{ $store.state.table.tambahModal }}
          </b-button>
        </CCol>
      </CRow>
      <CRow>
        <CCol>
          <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
            <template #Actions="{ item }">
              <td>
                <b-button
                  variant="warning"
                  class="mr-1"
                  v-c-tooltip.hover.click="$store.state.table.tooltipEdit"
                  v-b-modal.modal-edit-hirarki
                  @click="(data = item), (edit = !edit)"
                  :disabled="$store.state.role_aktif.kodeRole != 'super'"
                  ><CIcon name="cil-pencil" /> {{ item.actions }}</b-button
                >
                <b-button
                  variant="danger"
                  class="mr-1"
                  v-c-tooltip.hover.click="$store.state.table.tooltipHapus"
                  v-b-modal.modal-delete-hirarki
                  @click="data = item"
                  :disabled="$store.state.role_aktif.kodeRole != 'super'"
                  ><CIcon name="cil-trash" /> {{ item.actions }}</b-button
                >
              </td>
            </template>
          </CDataTable>
          <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
        </CCol>
      </CRow>
    </CCol>
    <modal-input :posisi="listPosisi" @alertFromChild="triggerAlert($event)" />
    <modal-edit :data="data" :posisi="listPosisi" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";

export default {
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  props: ["activeTab"],
  name: "Posisi",
  data() {
    return {
      edit: false,
      listPosisi: [],
      data: {},
      items: [],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        // {
        //   key: "namaDivisi",
        //   label: "Divisi",
        //   _style: "max-width: 70%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "mpa__namaPosisi",
          label: "Atasan",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        // {
        //   key: "namaDivisi",
        //   label: "Divisi",
        //   _style: "width: 40%;",
        //   sortDirection: "desc",
        //   class: "text-left",
        //   sorter: false,
        // },
        {
          key: "mpb__namaPosisi",
          label: "Bawahan",
          _style: "max-width: 70%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          class: "text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getPosisi();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    activeTab: function (newVal) {
      if (newVal == 2) {
        this.getDatas();
        this.getPosisi();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPosisi = await vm.$axios.post("levelAgreement/list", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listPosisi", listPosisi);
      vm.items =
        listPosisi.data.status == 200
          ? listPosisi.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                namaMitra: x.namaMitra || " - ",
              };
            })
          : [];
      // for (let i = 0; i < vm.items.length; i++) {
      //   let x = vm.items[i];
      //   x.no = i + 1;

      //   for (let a = 0; a < vm.options.length; a++) {
      //     const elA = vm.options[a];
      //     for (let b = 0; b < elA.pilihan.length; b++) {
      //       const elB = elA.pilihan[b];
      //       if (elB.value == x.kodePosisi) {
      //         x.namaKode = elB.text;
      //       }
      //     }
      //   }
      // }
      vm.totalRows = parseInt(listPosisi.data.count);
      vm.loading = false;
    },
    async getPosisi() {
      let vm = this;
      let listPosisi = await vm.$axios.post("masterPosisi/list");
      // console.log('listPosisi : ', listPosisi)
      vm.listPosisi =
        listPosisi.data.status == 200
          ? listPosisi.data.data.map((x) => {
              return {
                ...x,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.getDatas();
      vm.$store.commit("set_alert", event);
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
